<template>
  <el-row>
    <table-template :queryParams="queryParams" actionUrl="businessIntranet/findMySpreadProfitList.action"
                    ref="intranetProfitRecordTable">
      <template slot="search">
        <el-row>


          <el-form :inline="true" class="demo-form-inline">
            <el-form-item>
              <el-select  @change="$refs.intranetProfitRecordTable.search()" clearable placeholder="收益类型"
                          v-model="queryParams.type">
                <el-option :value="5" label="邀请注册"></el-option>
                <el-option :value="6" label="推广同行车源"></el-option>
                <el-option :value="7" label="推广朋友圈访问"></el-option>
                <el-option :value="8" label="开通会员奖励"></el-option>
                <el-option :value="9" label="购买车商群奖励"></el-option>
                <el-option :value="10" label="二手车置顶奖励"></el-option>
                <el-option :value="11" label="朋友圈置顶奖励"></el-option>
                <el-option :value="12" label="求购置顶奖励"></el-option>
                <el-option :value="13" label="充值推广通奖励"></el-option>
                <el-option :value="14" label="充值人脉奖励"></el-option>
                <el-option :value="15" label="申请提现"></el-option>
                <el-option :value="16" label="用户退款扣除"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-date-picker
                  @change="onDateTimeChange"
                  end-placeholder="结束日期"
                  range-separator="至"
                  start-placeholder="开始日期"
                  type="datetimerange"
                  v-model="queryParams.startEndTime">
              </el-date-picker>
            </el-form-item>

            <el-form-item>
              <el-button @click="$refs.intranetProfitRecordTable.search()" type="primary">搜索</el-button>
            </el-form-item>
          </el-form>
        </el-row>

      </template>
      <template slot="item">
        <el-table-column
            label="收益时间"
        >
          <template scope="scope">
            {{scope.row.createTime|dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column
            label="收益类型"
            prop="typeName">
        </el-table-column>

        <el-table-column
            label="金额(元)"
            prop="money">
          <template scope="scope">
            {{scope.row.profitInfo}}{{scope.row.money/100}}
          </template>
        </el-table-column>

        <el-table-column
            label="操作人"
            prop="actPhone">
        </el-table-column>



      </template>
    </table-template>
  </el-row>
</template>

<script>
import TableTemplate from '@/components/TableTemplate'
import BasicPager from '@/mixins/BasicPager'

export default {
  components: {
    TableTemplate
  },
  extends: BasicPager,
  name: 'intranetProfitRecord',
  data: function () {
    return {
      queryParams: {
        businessId: null
      }
    }
  },
  created () {
    let query = this.$route.query
    this.queryParams.employeeId = query.employeeId
  },
  methods: {
    onDateTimeChange (dates) {
      if (dates && dates.length === 2) {
        this.queryParams.startTime = dates[0].getTime()
        this.queryParams.endTime = dates[1].getTime()
      } else {
        this.queryParams.startTime = null
        this.queryParams.endTime = null
      }
      this.$refs.intranetProfitRecordTable.search()
    }
  },
  filters: {


  }
}
</script>

<style scoped>
</style>
